import { ButtonPrimary } from '@/components/button'
import { ArrowBack } from '@/components/icons'
import { useNavigate } from 'react-router-dom'
import ExternalScreen from './ExternalScreen'

export const ExternalThisAccountAlreadyTaken = () => {
  const navigate = useNavigate()

  const goBack = () => {
    navigate(-1)
  }

  return (
    <ExternalScreen>
      <div className="w-full h-full flex flex-col gap-y-6 items-center p-6">
        <div className="flex flex-row items-center justify-between w-full text-navy-900">
          <ArrowBack width={48} height={48} onClick={goBack} className="cursor-pointer" />
        </div>
        <div className="flex flex-col gap-y-4">
          <p className="text-2xl font-bold text-navy-900">This account is already taken</p>
          <p className="text-sm text-navy-900 text-opacity-70">
            If you believe this is you, and someone else has claimed your account, please contact our support team
          </p>
        </div>
        <div className="w-full">
          <ButtonPrimary title="Contact Support" className="w-full py-[14px] px-5" />
        </div>
      </div>
    </ExternalScreen>
  )
}

export default ExternalThisAccountAlreadyTaken
